
<template>
  <div class="PacienteDetalleOdontogramas">
    <v-row dense>
      <v-col
        cols="12"
        sm="6"
        md="4"
        v-for="odo in odontogramas"
        :key="odo.id"
      >
        <v-card outlined>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Fecha: {{_doDiaMesHoras(odo.fecha_odo)}}</v-list-item-title>
                <v-list-item-subtitle class="nowrap">
                  Médico: {{odo.medico}}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  icon
                  @click="idOdontograma=odo.id"
                >
                  <v-icon>visibility</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <odontograma-detalle
      v-model="idOdontograma"
      @msg="$emit('msg',$event)"
      @httpError="$emit('httpError',$event)"
    />
  </div>
</template>
<script>
import forms from "@/mixins/forms.js";
import dates from "@/mixins/dates.js";
import OdontogramaDetalle from "@/components/odontogramainfantil/OdontogramaDetalle.vue";
export default {
  components: { OdontogramaDetalle },
  name: "PacientesDetalleOdontogramasInfantiles",
  mixins: [forms, dates],
  props: {
    id: [String, Number],
  },
  data() {
    return {
      paciente: null,
      odontogramas: [],
      idOdontograma: null,
    };
  },
  methods: {
    _getOdontogramas() {
      if (this.id) {
        this._getThings("odontogramasinfantil/" + this.id, "odontogramas");
      }
    },
  },
  created() {
    this.paciente = this.id;
    this._getOdontogramas();
  },
  watch: {
    id() {
      this.paciente = this.id;
      this._getOdontogramas();
    },
  },
};
</script>

